import { Component } from "vue-property-decorator";
import ProductTile from "./ProductTile.vue";

@Component
export default class ProductAccessory extends ProductTile {
    constructor() {
        super();
    }
}
